import { render, staticRenderFns } from "./supFinanicalRecoList.vue?vue&type=template&id=5c4f5c25&scoped=true"
import script from "./supFinanicalRecoList.vue?vue&type=script&lang=js"
export * from "./supFinanicalRecoList.vue?vue&type=script&lang=js"
import style0 from "./supFinanicalRecoList.vue?vue&type=style&index=0&id=5c4f5c25&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4f5c25",
  null
  
)

export default component.exports